import { Component, OnInit, Inject } from '@angular/core';
import { DailyReviewService } from 'dm-src/app/modules/daily-review/daily-review.service';
import { AUTH_SERVICE_IMPL, IAuthenticationService } from 'shared';
import { PaySafePayment } from 'dm-src/dtos/pay-safe-payment';
import {
    IosAndAndroidNatvieFunctionsService,
    PostMessageResponse,
} from 'dm-src/services/ios-and-android-natvie-functions/ios-and-android-natvie-functions.service';
import { BehaviorSubject, Observable, filter, of } from 'rxjs';

@Component({
    selector: 'app-cash-payments',
    templateUrl: './cash-payments.component.html',
    styleUrls: ['./cash-payments.component.scss'],
})
export class CashPaymentsComponent implements OnInit {
    public paySafePayment: PaySafePayment = new PaySafePayment();
    public isNewWrapper = !!window.ReactNativeWebView;
    public clickOnPaySafeButton = false;
    currentPostMessage = new BehaviorSubject<PostMessageResponse>(
        {} as PostMessageResponse
    );
    osType: string;

    constructor(
        @Inject(AUTH_SERVICE_IMPL)
        private _authService: IAuthenticationService,
        private _dailyReviewService: DailyReviewService,
        private iosAndAndroidNatvieFunctionsService: IosAndAndroidNatvieFunctionsService
    ) {
        this.osType = this.iosAndAndroidNatvieFunctionsService.getMobileOperatingSystem();
    }

    public openPaySafePaymentUrlInBrowser(): void {
        this._dailyReviewService
            .createPaySafePayment(
                this.paySafePayment.paySafePaymentID,
                this.paySafePayment.paySafeMerchantRefNum,
                this.paySafePayment.orderCodes,
                this.paySafePayment.amount
            )
            .subscribe(
                (response) => {
                    if (response.status === 200) {
                        this.clickOnPaySafeButton = true;
                        const paySafeUrl = this.paySafeUrl;

                        if (this.osType === 'iOS') {
                            this.iosAndAndroidNatvieFunctionsService.sendToPostMessageBridge(
                                {
                                    command: 'openUrl',
                                    data: paySafeUrl,
                                }
                            );
                        }

                        if (this.isNewWrapper) {
                            paySafeUrl.replace('https', 'openurlinbrowser');
                        }

                        window.open(paySafeUrl, '_blank');
                    } else {
                        console.log(JSON.stringify(response));
                    }
                },
                (error) => {
                    console.log(JSON.stringify(error));
                }
            );
    }

    public get paySafeUrl(): string {
        return `${this.paySafePayment.paySafeUrl}?mid=${this.paySafePayment.paySafeMerchantID}&amount=${this.paySafePayment.amount}&reference=${this.paySafePayment.paySafeMerchantRefNum}`;
    }

    ngOnInit(): void {
        const userID = this._authService.currentUser.userID;
        this.clickOnPaySafeButton = false;
        this._dailyReviewService.getCashPayments(userID).subscribe((result) => {
            this.paySafePayment = result;
        });
    }
}
